module.exports = __webpack_public_path__ + "img/logo-small.8a0063d2.svg";